import { debounce } from 'debounce';
import { ResizeObserver as Polyfill } from '@juggle/resize-observer';
const ResizeObserver = window.ResizeObserver || Polyfill;

const scrollIndicatorHeight = 80,
    tolerance = 5;
class ScrollIndicator {

    constructor(el) {
        this.el = el;
        this.hasInteraction = false;
        this.active = false;
        this.scrollMode = false;
        // enable the styles for the scroll indicator with an additional class
        this.el.classList.add('scroll-indicator-enabled');
        // add resize observer
        this.ro = new ResizeObserver(() => {
            window.requestAnimationFrame(()=> {
                debounce(this.check(), 200);
            });
        });
        this.ro.observe(this.el); // Watch dimension changes wrapping element
    }

    check() {
        if(!this.hasInteraction) {
            let sh = this.el.scrollHeight,
                ch = this.el.clientHeight;
            this.scrollMode = ((sh - ch) > tolerance) && (ch >= scrollIndicatorHeight);
            if(this.scrollMode && !this.active) {
                // show indicator
                this.el.classList.add('scroll-indicator-active');
                this.active = true;
                // hide on scroll or interaction
                this.el.addEventListener('scroll', () => {
                    this.hide();
                });
                this.el.addEventListener('focusin', () => {
                    this.hide();
                });
                this.el.addEventListener('mouseenter', () => {
                    this.hide();
                });
                this.el.addEventListener('touchstart', () => {
                    this.hide();
                });
            } else if(!this.scrollMode) {
                // hide indicator
                this.el.classList.remove('scroll-indicator-active');
                this.active = false;

            }
        }
    }
    
    hide() {
        if(this.active) {
            // hide indicator
            this.el.classList.remove('scroll-indicator-active');
            this.hasInteraction = true;
            this.active = false;
        }
    }
}

const isIOSDevice = () => {
    let test = ((/iPad|iPhone|iPod/.test(navigator.platform) ||  /iPad|iPhone|iPod/.test(navigator.userAgent)) && !window.MSStream) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints && navigator.maxTouchPoints === 5);
    return test;
}

// export the default function to create
export function createFrom(wrappers) {
    if(isIOSDevice()) {
        wrappers.forEach((node) => {
            // if node is an element
            if (node.nodeType === 1) {
                new ScrollIndicator(node);
            }
        });
    }
}